export default __webpack_public_path__ + "static/media/kinder2.c5d17f04.jpg";